export default __webpack_public_path__ + "static/media/3WL_upgrade.ba604479.jpg";